import { render, staticRenderFns } from "./AppCurrencyPill.vue?vue&type=template&id=6c5889d0&scoped=true"
import script from "./AppCurrencyPill.vue?vue&type=script&lang=js"
export * from "./AppCurrencyPill.vue?vue&type=script&lang=js"
import style0 from "./AppCurrencyPill.vue?vue&type=style&index=0&id=6c5889d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5889d0",
  null
  
)

export default component.exports